<script lang="ts">
  export let font: 'pp-neue-machina' | 'pilat-wide';
</script>

<span class={font}>
  <slot />
</span>

<style lang="scss">
  .pp-neue-machina {
    font-family: var(--font-family-secondary);
  }

  .pilat-wide {
    font-family: var(--font-family-primary);
  }
</style>
